import React from 'react';
import Typography from "@material-ui/core/Typography/Typography";
import PropTypes from "prop-types";

export default function TabContainer({ className, children }) {
    return (
        <div className={className}>
            <Typography component="div">
                {children}
            </Typography>
        </div>
    );
}

TabContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
